import React from "react";
import { get, some } from "lodash";
import { Col, Form, Row } from "react-bootstrap";
import {
  inviteStatusToType,
  inviteStatusToEnglish,
} from "statics/statusToEnglishMapping";
import IconTable, { IconTableColumn } from "../../../../components/IconTable";
import StatusBox from "components/StatusBox";

import "./UploadFailed.scss";

interface UploadJobError {
  type?: string;
  format?: string;
  // (sic) — original PropTypes key is misspelled "resaon"; preserved verbatim
  resaon?: string;
}

export interface FailedJob {
  id?: string | number;
  filename?: string;
  status?: string;
  group?: { name?: string };
  errors?: UploadJobError[];
}

interface Props {
  // PropTypes declared failedJob as arrayOf(object), but the component reads it
  // as a single object unconditionally; typed to match real usage. Required so
  // the unconditional property accesses preserve throw-on-undefined behavior.
  failedJob: FailedJob;
}

export class UploadFailed extends React.PureComponent<Props> {
  _groupName = () => {
    const groupName = get(this.props.failedJob, "group.name");
    const { id } = this.props.failedJob;

    return (
      <div className="group-select" key={id}>
        <Row className="mb-3">
          <Form.Group as={Col} sm={6} controlId="formBasicGroupId">
            <Form.Label>Group</Form.Label>
            <Form.Control placeholder={groupName} disabled />
          </Form.Group>
        </Row>
      </div>
    );
  };

  _buildColumns = (): Array<IconTableColumn<UploadJobError>> => {
    const { filename, status } = this.props.failedJob;

    const columns: Array<IconTableColumn<UploadJobError>> = [
      {
        label: "File Name",
        customComponent: () => {
          return (
            <div>
              <div className="uploaded-file">
                <div className="file-type">
                  <img className="png" src="/assets/file.png"></img>
                </div>
                <p className="file"> {filename}</p>
              </div>
            </div>
          );
        },
      },

      {
        label: "Reason",
        key: "reason",
      },
      {
        label: "Format",
        key: "format",
        customComponent: () => {
          // Unconditional array access preserved (non-null assertion keeps the
          // original throw-on-undefined behavior; errors is optional in the type).
          const [{ format }] = this.props.failedJob.errors!;
          // (sic) the original iterates `format` (a string) with lodash `some`,
          // reading `error.format` off each char. Behavior preserved verbatim;
          // the cast only satisfies lodash's collection overload.
          const hasFormat = some(
            format as unknown as ArrayLike<{ format?: unknown }>,
            (error) => error.format !== null
          );
          const showFormat = hasFormat ? format : " None ";
          return showFormat;
        },
      },
      {
        label: "Status",
        customComponent: () => {
          return (
            <StatusBox
              status={
                inviteStatusToEnglish[
                  status as keyof typeof inviteStatusToEnglish
                ]
              }
              type={
                inviteStatusToType[status as keyof typeof inviteStatusToType]
              }
            />
          );
        },
      },
    ];
    return columns;
  };

  render() {
    const groupName = this._groupName();
    const columns = this._buildColumns();

    return (
      <div className="add-employee-form" style={{ marginBottom: 8 }}>
        <div>{groupName}</div>
        <Form.Label>Error Details</Form.Label>
        <IconTable columns={columns} data={this.props.failedJob.errors} />
      </div>
    );
  }
}

export default UploadFailed;
